import AddRetailers from 'components/retailersList/AddRetailer';
import EditRetailers from 'components/retailersList/EditRetailer';
import { MieleOnlyRoute } from 'components/authentication/MieleOnlyRoute';
import { ROUTES } from 'constants/routes';
import SidebarLayout from 'layouts/SidebarLayout';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const Retailers = lazy(() => import('components/retailersList'));
const RetailerStats = lazy(() => import('components/stats'));
const PoliciesLedger = lazy(() => import('pages/PoliciesLedger'));

const dashboardRoutes = [
  {
    path: `/${ROUTES.DASHBOARD}`,
    element: <SidebarLayout requiredRoles={['admin']} />,

    children: [
      {
        path: '',
        element: <Navigate to={ROUTES.RETAILERS} replace />,
      },
      {
        path: `${ROUTES.RETAILERS}`,
        element: <Retailers />,
      },
      {
        path: ROUTES.ADD_RETAILERS,
        element: <AddRetailers />,
      },
      {
        path: `${ROUTES.EDIT_RETAILERS}/:id`,
        element: <EditRetailers />,
      },
      {
        path: ROUTES.POLICIES_LEDGER,
        element: (
          <MieleOnlyRoute>
            <PoliciesLedger />
          </MieleOnlyRoute>
        ),
      },
    ],
  },
  {
    path: `/${ROUTES.RETAILER_STATS}`,
    element: <SidebarLayout requiredRoles={['referrer']} />,

    children: [
      {
        path: '',
        element: <RetailerStats />,
      },
    ],
  },
];

export default dashboardRoutes;
